import { render, staticRenderFns } from "./MarginCogsMetricConfigurationPage.vue?vue&type=template&id=5fdb0424"
import script from "./MarginCogsMetricConfigurationPage.vue?vue&type=script&lang=ts"
export * from "./MarginCogsMetricConfigurationPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports